import { useEffect, useState, useCallback } from 'react';

// Ctrl+Shift+A toggles the super_admin drawer.
export function useAdminDrawer() {
  const [open, setOpen] = useState(false);
  const openDrawer = useCallback(() => setOpen(true), []);
  const closeDrawer = useCallback(() => setOpen(false), []);
  const toggleDrawer = useCallback(() => setOpen(p => !p), []);

  useEffect(() => {
    function onKeydown(e) {
      const meta = e.ctrlKey || e.metaKey;
      if (meta && e.shiftKey && (e.key === 'A' || e.key === 'a')) {
        e.preventDefault();
        setOpen(prev => !prev);
      }
    }
    window.addEventListener('keydown', onKeydown);
    return () => window.removeEventListener('keydown', onKeydown);
  }, []);

  return { open, openDrawer, closeDrawer, toggleDrawer };
}
